import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
interface ConfirmedItem {
  name: string;
  color: string;
  size: string;
  quantity: number;
  price: number;
}
interface OrderState {
  orderNumber?: string;
  items?: ConfirmedItem[];
  total?: number;
  email?: string;
}
export function OrderConfirmation() {
  const location = useLocation();
  const state = location.state as OrderState || {};
  if (!state.orderNumber) {
    return <div className="py-32 px-4 text-center max-w-xl mx-auto" data-id="element-278">
        <h1 className="font-display text-4xl tracking-wide mb-4" data-id="element-279">
          No order to show
        </h1>
        <p className="text-neutral-400 mb-8" data-id="element-280">
          Looks like you reached this page directly.
        </p>
        <Link to="/shop" className="inline-block bg-vsc-gold text-black font-medium px-8 py-4 hover:bg-white transition-colors rounded-sm" data-id="element-281">
          Shop the Collection
        </Link>
      </div>;
  }
  return <div className="py-20 px-4 max-w-2xl mx-auto w-full" data-id="element-282">
      <div className="text-center mb-12" data-id="element-283">
        <CheckCircle size={56} className="text-vsc-gold mx-auto mb-6" data-id="element-284" />
        <h1 className="font-display text-5xl tracking-wide mb-3" data-id="element-285">
          Order Confirmed
        </h1>
        <p className="text-neutral-400" data-id="element-286">
          Thanks for your order. A confirmation has been sent to{' '}
          <span className="text-white" data-id="element-287">{state.email}</span>.
        </p>
        <p className="text-neutral-400 mt-2" data-id="element-288">
          Order number:{' '}
          <span className="text-vsc-gold font-medium" data-id="element-289">{state.orderNumber}</span>
        </p>
      </div>

      <div className="bg-neutral-900/40 border border-neutral-800 rounded-sm p-6 mb-10" data-id="element-290">
        <h2 className="font-display text-2xl tracking-wide mb-6" data-id="element-291">Your Items</h2>
        <div className="space-y-4" data-id="element-292">
          {state.items?.map((item, idx) => <div key={idx} className="flex justify-between items-start gap-4" data-id="element-293">
              <div data-id="element-294">
                <p className="font-medium" data-id="element-295">{item.name}</p>
                <p className="text-xs text-neutral-400 mt-0.5" data-id="element-296">
                  {item.color} / {item.size} · Qty {item.quantity}
                </p>
              </div>
              <p className="font-medium whitespace-nowrap" data-id="element-297">
                ${item.price * item.quantity}
              </p>
            </div>)}
        </div>
        <div className="flex justify-between items-center pt-5 mt-5 border-t border-neutral-800" data-id="element-298">
          <span className="font-medium" data-id="element-299">Total Paid</span>
          <span className="font-display text-2xl" data-id="element-300">${state.total}</span>
        </div>
      </div>

      <div className="text-center" data-id="element-301">
        <Link to="/shop" className="inline-block bg-vsc-gold text-black font-medium px-8 py-4 hover:bg-white transition-colors rounded-sm" data-id="element-302">
          Continue Shopping
        </Link>
      </div>
    </div>;
}